import { render, staticRenderFns } from "./Pacotes.vue?vue&type=template&id=6dbb4dd4&scoped=true&"
import script from "./Pacotes.vue?vue&type=script&lang=js&"
export * from "./Pacotes.vue?vue&type=script&lang=js&"
import style0 from "./Pacotes.vue?vue&type=style&index=0&id=6dbb4dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb4dd4",
  null
  
)

export default component.exports